import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: 'FilePlus',
      label: 'New Case',
      description: 'Start fire forensics analysis',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      path: '/new-case-creation-wizard',
    },
    {
      icon: 'Users',
      label: 'Find Expert',
      description: 'Browse marketplace',
      color: 'text-success',
      bgColor: 'bg-success/10',
      path: '/expert-marketplace-listing',
    },
    {
      icon: 'FileText',
      label: 'View Reports',
      description: 'Access completed reports',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      path: '/report-viewer',
    },
    {
      icon: 'CreditCard',
      label: 'Billing',
      description: 'Manage subscription',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      path: '/landing-page',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {actions?.map((action) => (
        <button
          key={action?.label}
          onClick={() => navigate(action?.path)}
          className="bg-card border border-border rounded-lg p-4 md:p-6 transition-smooth hover:shadow-elevation-md hover:-translate-y-1 text-left"
        >
          <div className={`w-12 h-12 rounded-lg ${action?.bgColor} flex items-center justify-center mb-3`}>
            <Icon name={action?.icon} size={24} className={action?.color} />
          </div>
          <h3 className="font-semibold text-base text-foreground mb-1">{action?.label}</h3>
          <p className="caption text-muted-foreground">{action?.description}</p>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;